<template>
  <div>
    <div v-if="blog" class="bg-warmgray-super-light">
      <ContentHowTopSection :blog="blog" />
    </div>
    
    <!-- Loopar alla artiklar med Tag Feature -->
      <UiImageFlip v-if="blog" 
        v-for="(article, index) in blogStore.filterArticlesByTag(blog, 'Feature')" 
        :key="index" 
        :article="article"
        :class="{'mt-16': index !== 0, 'mt-24': index === 0}" 
      />
      
    <div class="mt-24 mb-16">
    <UiHeroBottom v-if="bottomHeroArticle" 
      :article="bottomHeroArticle" />    
    </div>
    
  </div> 
</template>
  
<script setup>
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();

// Definiera props
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});

const bottomHeroArticle = computed(() => {
  try{
    return blogStore.filterArticlesByTag(props.blog, 'Herobottom')[0] || null;
  }
  catch (error) {
    console.error('Error fetching bottom hero article:', error);
    return null;
  }
});


</script>
  
  
<style scoped>
/* Adjust spacing for smaller screens */
@media (max-width: 768px) {


  .mt-24 {
    margin-top: 36px;
  }

  .mt-16, .mb-16 {
    margin-top: 36px;
    margin-bottom: 36px;
  }
}  

@media (max-width: 480px) { /* Extra small screens */
  .mt-24 {
    margin-top: 24px;
  }

  .mt-16, .mb-16 {
    margin-top: 24px;
    margin-bottom: 24px;
  }
}

</style>
  
  